import { Button } from '@malesia/react-components/dist/src/components/Button';
import { PageTitle } from '@malesia/react-components/dist/src/components/Page/Title';
import { SFC } from '@malesia/react-components/dist/src/types/react';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { allAdminRoutePaths } from '../../../containers/Routes/allAdminRoutePaths';
import { agentListPermissions } from '../../../permissions/adminPages/user/agentList';
import { useUserPermissions } from '../../../permissions/useUserPermissions';

export const AgentListHeaderWithStore: SFC = () => {
    const userPermissions = useUserPermissions();

    return (
        <PageTitle
            text={
                <FormattedMessage
                    id='front-app/AgentListPage:Title'
                    defaultMessage='Agents'
                />
            }
            rightSlot={
                <Link to={allAdminRoutePaths.userAgentNew}>
                    <Button
                        icon='plus'
                        text={
                            <FormattedMessage
                                id='front-app/Agent/List:AddNewAgent'
                                defaultMessage='Add new agent'
                            />
                        }
                    />
                </Link>
            }
            rightSlotHidden={!userPermissions.has(agentListPermissions.newAgentLink)}
        />
    );
};
